import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { DeliveryRateApiAdapter } from '../adapters/DeliveryRateApiAdapter';
import type { DeliveryRateResponse } from '../models/DeliveryRate';

const httpClient = createHttpClient(apiClientWH);
const adapter = new DeliveryRateApiAdapter(httpClient);

export const useOrderDeliveryRate = () => {
  const { orderId } = useParams<{ orderId: string }>();

  return useQuery<DeliveryRateResponse | undefined>({
    queryKey: ['orderDeliveryRate', orderId],
    queryFn: async () => {
      if (!orderId) return undefined;
      return adapter.getOrderDeliveryRate(Number(orderId));
    },
    enabled: Boolean(orderId),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
